import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import { AUTH_TOKEN, FORCE_CHANGE_PASS } from "store/auth/login/actionTypes";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => {
  const history = useHistory();
  return (
    <Route
      {...rest}
      render={props => {
        // force-change-password
        if (
          location.pathname !== "/change-password" &&
          localStorage.getItem(FORCE_CHANGE_PASS) === "true"
        ) {
          return (
            <Redirect
              to={{
                pathname: "/change-password",
                state: { from: props.location },
              }}
            />
          );
        }
        if (isAuthProtected && !localStorage.getItem(AUTH_TOKEN)) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
        if (rest.path === "/login" && localStorage.getItem(AUTH_TOKEN)) {
          history.push("/dashboard");
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;
